import { updateApiData } from "../../../utils/utils";

export const updatePassword = async (appInfo,values) => {
    const api="user/update";
    const location = {
        path:"accountUpdate",
        values
    }
    return await updateApiData(appInfo,api,location)
}